// מבנה "תעודת הזהות הרגשית" של שיחה (calls.meta.ai_emotions מה-BE).
export type EmotionKey =
  | 'happy' | 'satisfied' | 'neutral' | 'confused' | 'concerned' | 'frustrated' | 'angry';

export interface StrongestEmotion { emotion: EmotionKey; score: number }
export interface SpeakerProfile {
  traits: string[];
  strongest_emotions: StrongestEmotion[];
  arc?: string;
}
export interface TimelinePoint {
  t: number;               // שניות מתחילת השיחה
  speaker: 'agent' | 'customer';
  emotion: EmotionKey;
  valence: number;         // -1..1
  prosody?: { top: string; score: number };
}
export interface KeyMoment {
  t: number;
  speaker: 'agent' | 'customer';
  phrase: string;
  emotion: EmotionKey;
}
export interface CallEmotions {
  speakers: { agent?: SpeakerProfile; customer?: SpeakerProfile };
  timeline: TimelinePoint[];
  key_moments: KeyMoment[];
  overall?: { resolved?: boolean; customer_start?: EmotionKey; customer_end?: EmotionKey; summary?: string };
  engine?: string;
  analyzed_at?: string;
}

// עברית + אמוג'י + צבע לכל רגש (לשימוש בגרף, בצ'יפים וברגעי מפתח).
export const EMOTION_META: Record<EmotionKey, { he: string; emoji: string; color: string }> = {
  happy:      { he: 'שמח',      emoji: '😄', color: '#16a34a' },
  satisfied:  { he: 'מרוצה',    emoji: '🙂', color: '#65a30d' },
  neutral:    { he: 'ניטרלי',   emoji: '😐', color: '#a3a3a3' },
  confused:   { he: 'מבולבל',   emoji: '😕', color: '#d97706' },
  concerned:  { he: 'מודאג',    emoji: '😟', color: '#ea580c' },
  frustrated: { he: 'מתוסכל',   emoji: '😠', color: '#dc2626' },
  angry:      { he: 'כועס',     emoji: '😡', color: '#b91c1c' },
};

export const emotionMeta = (e?: string) =>
  EMOTION_META[(e as EmotionKey)] ?? EMOTION_META.neutral;
